// extracted by mini-css-extract-plugin
export default {"deleteCalendarButton":"delete-calendar-button_deleteCalendarButton__6i+jQ","icon":"delete-calendar-button_icon__ih40x"};